// Bus event names for the agent AI reply assistant. Shared between the header
// toggle (which emits) and ReplyBox (which owns the input box content and so
// actually starts the draft after confirming any existing text).
export const AI_ASSIST_REQUEST_DRAFT = 'CUSTOM_AI_ASSIST_REQUEST_DRAFT';

// Fired when a customer (incoming) message arrives, so ReplyBox can decide
// whether to auto-draft (only when the per-conversation auto switch is on).
export const AI_ASSIST_INCOMING = 'CUSTOM_AI_ASSIST_INCOMING';
